import { useQuery } from '@tanstack/react-query';
import { getGamePackReport } from 'services/scratcherService';
import GamePackReportModel from 'models/scratcher/GamePackReportModel';

export function useGamePackReport(storeId?: string) {
  const queryResult = useQuery<GamePackReportModel, Error>({
    queryKey: ['game-pack-report', storeId],
    queryFn: async () => {
      if (!storeId) {
        return GamePackReportModel.createEmpty();
      }

      const response = await getGamePackReport(storeId);
      if (response.success && response.data) {
        return GamePackReportModel.fromServerData(response.data);
      }

      throw new Error(response.error || 'Failed to load game pack report');
    },
    staleTime: 1 * 60 * 1000,
    enabled: !!storeId,
  });

  const reportModel = queryResult.data ?? GamePackReportModel.createEmpty();

  return {
    reportModel,
    summary: reportModel.summary,
    rows: reportModel.toRowFormat(),
    packExportRows: reportModel.toPackExportRows(),
    isLoading: queryResult.isLoading,
    isError: queryResult.isError,
    error: queryResult.error ?? null,
  };
}
